import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { SplashScreen } from "@capacitor/splash-screen";
import App from "./App.tsx";
import { initializeAnalytics } from "./integrations/analytics/client";
import "./index.css";

const MIN_SPLASH_DURATION_MS = 2000;
const appStartTime = Date.now();

// Analytics init touches storage and network. If it throws, mounting the app
// still has to happen — otherwise the user gets a blank page.
try {
	initializeAnalytics();
} catch (error) {
	console.error("[bootstrap] Analytics init failed", error);
}

const hideNativeSplashWhenReady = async () => {
	if (!Capacitor.isNativePlatform()) return;

	const elapsed = Date.now() - appStartTime;
	const remaining = Math.max(0, MIN_SPLASH_DURATION_MS - elapsed);

	if (remaining > 0) {
		await new Promise((resolve) => setTimeout(resolve, remaining));
	}

	const splashPlugin = SplashScreen;
	if (splashPlugin?.hide) {
		await splashPlugin.hide();
	}
};

createRoot(document.getElementById("root")!).render(<App />);

void hideNativeSplashWhenReady();
